export enum ViewName {
  Editor = 'editor',
  Show = 'show',
  Preview = 'preview',
  PreviewMulti = 'previewMulti',
}
